import React from 'react';
import { connect } from 'react-redux';
import { useParams, withRouter } from 'react-router-dom';
import { ButtonStyled } from '@nike/nike-design-system-components';
import { compose } from 'redux';

import { array, bool, func, object } from 'prop-types';
import Modal from '../../../modal/Modal';
import { updateProductContractGroup as updateProductContractGroupAction } from '../actions';
import { getProductContractGroupById } from '../selectors';

const DeleteContractModal = ({
  isOpen,
  closeModal,
  contractToDelete,
  linkedContractIds,
  updateProductContractGroup
}) => {
  const { productContractGroupId } = useParams();
  const title = 'Confirm Contract Delete';

  const content = () => (!contractToDelete ? null : `Are you sure you want to delete ${contractToDelete?.poNumber}?`);

  const footer = ({ isLoading, toggleIsLoading }) => {
    const handleDelete = async () => {
      toggleIsLoading('Deleting contract...');

      await updateProductContractGroup({
        productContractGroupId,
        data: { contracts: linkedContractIds.filter(id => id !== contractToDelete?.sourceContractId) }
      });

      toggleIsLoading();
      closeModal();
    };

    return (
      <>
        <ButtonStyled
          type='button'
          appearance='primary'
          background='light'
          size='small'
          className='responsive-button'
          onClick={handleDelete}
          disabled={isLoading}
          data-testid='confirmDeleteContractButton'
        >
          Delete
        </ButtonStyled>
        <ButtonStyled
          type='button'
          appearance='secondary'
          background='light'
          size='small'
          className='responsive-button'
          onClick={closeModal}
          disabled={isLoading}
        >
          Cancel
        </ButtonStyled>
      </>
    );
  };

  return <Modal title={title} content={content} footer={footer} isOpen={isOpen} closeModal={closeModal} />;
};

DeleteContractModal.propTypes = {
  contractToDelete: object.isRequired,
  linkedContractIds: array.isRequired,
  updateProductContractGroup: func.isRequired,
  closeModal: func.isRequired,
  isOpen: bool.isRequired
};

const mapStateToProps = (state, { match }) => ({
  linkedContractIds: getProductContractGroupById(state, match?.params?.productContractGroupId)?.contracts
});

export default compose(
  withRouter,
  connect(mapStateToProps, { updateProductContractGroup: updateProductContractGroupAction })
)(DeleteContractModal);
